export enum ListExportsType{
    REPORT_XML = "REPORT_XML", 
    SIM = "SIM", 
    SMARTPHONE = "SMARTPHONE",
    APPOINTMENT_CC = "APPOINTMENT_CC"
}

export class ListExportsRequest{
    email: string;
    type: ListExportsType;
    
}

export class ListExportsRequestSearch{
    email: string;
    pageNumber: number;
    pageSize: number;
    sortBy: string;
    type: string;
    published: boolean;
    
}